<template>
    <div class="timeline-event-treatment">
        <div class="timeline-event-treatment__subtitle">
            TRATAMIENTO
        </div>
        <event-treatment-detail :doctor_names="doctor_names" @note="note" @done="done" :treatment="entity"
            :event="event" @assign="assign" @appointment="appointment"></event-treatment-detail>
    </div>
</template>

<script>
export default {
    props: ['event', 'entity', 'doctor_names'],
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters(['msgwindow', 'errorwindow', 'clinic'])
    },
    methods: {
        note(treatment) {
            this.$emit('note', this.event, treatment);
        },
        done(treatment) {
            this.$emit('done', this.event, treatment);
        },
        assign(treatment) {
            this.$emit('assign', this.event, treatment);
        },
        appointment(treatment) {
            this.$emit('appointment', this.event, treatment);
        },
    }
}
</script>

<style lang="scss">
.timeline-event-treatment {
    &__title {
        font-size: 15px;
        font-weight: 700;
    }

    &__subtitle {
        margin-top: 15px;
        font-size: 12px;
        font-weight: 500;
    }

    &__text {
        font-size: 14px;
        font-weight: 500;

        p {
            margin-bottom: 8px;
        }

        p:last-child {
            margin-bottom: 0;
        }
    }

}
</style>
